import type { Deployment, BatchSizeChartDataPoint } from '../../../common/types';

export const convertToDataPoints = (data: Deployment[]): BatchSizeChartDataPoint[] =>
	data.map((deployment) => ({
		name: deployment.id,
		// @ts-expect-error - TS2339 - Confusion between JS Date and GraphQL date scalar
		value: [deployment.lastUpdated.getTime(), deployment.issueCount],
		customInfo: {
			issueCount: deployment.issueCount,
			pipeline: deployment.pipeline,
			environment: deployment.environment,
		},
	}));
